/* Zabi RPDP — bundelblok: live totaal/besparing + alle geselecteerde producten
   in één keer toevoegen (/cart/add.js met items[]), daarna cart-drawer openen. */
(function () {
  var root = document.querySelector('[data-zabi-bundle]');
  if (!root) return;

  var cards = root.querySelectorAll('[data-zabi-bundle-card]');
  var totalEl = root.querySelector('[data-zabi-bundle-total]');
  var saveEl = root.querySelector('[data-zabi-bundle-save]');
  var countEl = root.querySelector('[data-zabi-bundle-count]');
  var addBtn = root.querySelector('[data-zabi-bundle-add]');
  var moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function money(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: moneyFormat }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function selected() {
    return [].slice.call(root.querySelectorAll('[data-zabi-bundle-input]')).filter(function (i) { return i.checked; });
  }

  function refresh() {
    var sel = selected();
    var total = 0;
    var compare = 0;
    sel.forEach(function (i) {
      total += parseInt(i.getAttribute('data-price'), 10) || 0;
      compare += parseInt(i.getAttribute('data-compare'), 10) || 0;
    });
    if (totalEl) totalEl.textContent = money(total);
    if (countEl) countEl.textContent = sel.length;
    if (saveEl) {
      var diff = compare - total;
      if (diff > 0) {
        saveEl.textContent = (saveEl.getAttribute('data-label') || 'bespaar') + ' ' + money(diff);
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
    if (addBtn) addBtn.disabled = sel.length === 0;
    cards.forEach(function (c) {
      var input = c.querySelector('[data-zabi-bundle-input]');
      c.classList.toggle('is-checked', !!(input && input.checked));
    });
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-zabi-bundle-input]')) refresh();
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var items = selected().map(function (i) {
        return { id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 };
      });
      if (!items.length) return;
      addBtn.disabled = true;
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var drawer = document.querySelector('cart-drawer.zabi-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents();
          } else {
            window.location.href = root_url + 'cart';
          }
        })
        .finally(function () { addBtn.disabled = false; refresh(); });
    });
  }

  refresh();
})();
